import * as React from "react";
import {
  Button,
  Container,
  BreadcrumbItem,
  Breadcrumb,
  Row,
  Col
} from "reactstrap";
import { Link } from "react-router-dom";
import { bindActionCreators, compose } from "redux";
import { licencesAction } from "../../_actions";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { withTranslation, language } from "react-i18next";

class LicenceListState extends React.Component<any, any> {
  constructor(props:any) {
    super(props);
    const i18nextLng = localStorage.getItem("i18nextLng");

      this.state = {
        locales: i18nextLng ? i18nextLng : "en"
      }
  }

  componentDidMount() {
    this.props.load();
  }

  formatDate(date: any, lang: any) {
    let day = date.slice(8, 10);
    let month = date.slice(5, 7);
    let year = date.slice(0, 4);
    switch (lang) {
      case "cs":
        day = day[0] == 0 ? day[1] : day;
        month = month[0] == 0 ? month[1] : month;
        return day + ". " + month + ". " + year;
      default:
        return month + "/" + day + "/" + year;
    }
  }

  onFilteredChangeCustom(value: any, accessor: any) {
    let filtered = this.state.filtered;
    let insertNewFilter = 1;

    if (filtered.length) {
      filtered.forEach((filter: any, i: any) => {
        if (filter["id"] === accessor) {
          if (value === "" || !value.length) filtered.splice(i, 1);
          else filter["value"] = value;

          insertNewFilter = 0;
        }
      });
    }

    if (insertNewFilter) {
      filtered.push({ id: accessor, value: value });
    }

    this.setState({ filtered: filtered });
  }

  render() {
    const { licences, t, i18next } = this.props;
  console.log(i18next)
    return (
      <Container>
        <Breadcrumb>
          <BreadcrumbItem><Link to="/">Sypal</Link></BreadcrumbItem>
          <BreadcrumbItem active>{t('licence_list')}</BreadcrumbItem>
        </Breadcrumb>
          <Row>
            <Col xs="12" style={{textAlign: "center", marginBottom: "25px", padding: "0.375rem 3.75rem"}}>
              <Link to={`new-licence`}>
                <Button className="new-licence" color="success">
                  {t('create_new_licence')}
                </Button>
              </Link>
            </Col>
          </Row>
          <ReactTable
            data={licences.data}
            // filterable
            filtered={this.state.filtered}
            minRows={0}
            pageSizeOptions={[5, 20, 30, 50, 100]}
            onFilteredChange={(filtered: any, column: any, value: any) => {
              this.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
            defaultFilterMethod={(filter: any, row: any, column: any) => {
              const id = filter.pivotId || filter.id;
              if (typeof filter.value === "object") {
                return row[id] !== undefined
                  ? filter.value.indexOf(row[id]) > -1
                  : true;
              } else {
                return row[id] !== undefined
                  ? String(row[id]).indexOf(filter.value) > -1
                  : true;
              }
            }}
            previousText={t('table_controls.previous')}
            nextText={t('table_controls.next')}
            loadingText={t('table_controls.loading')}
            noDataText={t('table_controls.no_rows_found')}
            pageText={t('table_controls.page')}
            ofText={t('table_controls.of')}
            rowsText={t('table_controls.rows')}
            columns={[
              {
                Header: "ID",
                accessor: "id",
                show: false
              },
              {
                Header: t('name'),
                accessor: "name",
                style: {fontWeight: "bold", margin: "auto"},
                Cell: (cellInfo: any) => {
                  return (
                    <Link className="detail-link" to={"licence-detail/" + cellInfo.original.id}>
                      {cellInfo.original.name}
                    </Link>
                    )
                }
              },
              {
                Header: t('available_from'),
                accessor: "avaiableFrom",
                filterable: false,
                style: { margin: "auto", textAlign: "center" },
                Cell: (cellInfo: any) => {
                  // let date = cellInfo.original.avaiableFrom;
                  // let day = date.slice(8, 10);
                  // let month = date.slice(5, 7);
                  // let year = date.slice(0, 4);
                  // if(t('admin:lang') == "cs") {
                  //   day = day[0] == 0 ? day[1] : day;
                  //   month = month[0] == 0 ? month[1] : month;
                  //   return (<div> day + ". " + month + ". " + year </div>);
                  //   } else return (<div>month + "/" + day + "/" + year</div>);
                  // }
                  return <div>{this.formatDate(cellInfo.original.avaiableFrom, t('admin:lang'))}</div>;
                }
              },
              {
                Header: t('available_to'),
                accessor: "avaiableTo",
                filterable: false,
                style: { margin: "auto", textAlign: "center" },
                Cell: (cellInfo: any) => {
                  return <div>{this.formatDate(cellInfo.original.avaiableTo, t('admin:lang'))}</div>;
                }
              },
              {
                Header: t('actions'),
                accessor: "actions",
                filterable: false,
                width: 150,
                maxWidth: 180,
                Cell: cellInfo => (
                  <div style={{ justifyContent: "center", display: "flex" }}>
                    <Link to={`licence-detail/${cellInfo.original.id}`}>
                      <Button
                        color="secondary"
                        style={{ margin: "0", padding: ".25rem .5rem" }}
                      >
                      <svg style={{marginLeft: "0px"}} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                          fill="#ffffff" />
                        <path d="M0 0h24v24H0z" fill="none"/>
                      </svg>
                      </Button>
                    </Link>
                  </div>
                )
              }
            ]}
            className="-striped -highlight"
          />
          </Container>
    );
  }
}

const mapStateToProps = (state:any) => {
  return {
    licences: state.licences
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({
    load: licencesAction.loadLicences
  }, dispatch);
}

const LicenceListStateComponent = compose(
  withTranslation('licences'),
  connect(mapStateToProps, mapDispatchToProps))
(LicenceListState);

export { LicenceListStateComponent as LicenceList };
